@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --font-heading: 'Plus Jakarta Sans', ui-sans-serif, system-ui, sans-serif;
  --font-body: 'Inter', ui-sans-serif, system-ui, sans-serif;
  --font-label: 'Inter', ui-sans-serif, system-ui, sans-serif;

  --background-50: 0.995 0.001 110;
  --background-100: 0.975 0.003 110;
  --background-200: 0.935 0.004 110;
  --background-300: 0.87 0.005 110;
  --background-400: 0.74 0.006 110;
  --background-500: 0.6 0.006 110;
  --background-600: 0.48 0.006 110;
  --background-700: 0.37 0.006 110;
  --background-800: 0.27 0.005 110;
  --background-900: 0.19 0.004 110;
  --background-950: 0.12 0.003 110;

  --foreground-50: 0.965 0.003 265;
  --foreground-100: 0.925 0.004 265;
  --foreground-200: 0.865 0.005 265;
  --foreground-300: 0.745 0.006 265;
  --foreground-400: 0.6 0.008 265;
  --foreground-500: 0.48 0.009 265;
  --foreground-600: 0.38 0.009 265;
  --foreground-700: 0.3 0.008 265;
  --foreground-800: 0.23 0.007 265;
  --foreground-900: 0.17 0.006 265;
  --foreground-950: 0.115 0.005 265;

  --primary-50: 0.965 0.024 264;
  --primary-100: 0.92 0.05 264;
  --primary-200: 0.855 0.085 264;
  --primary-300: 0.75 0.132 264;
  --primary-400: 0.64 0.188 264;
  --primary-500: 0.52 0.242 264;
  --primary-600: 0.46 0.222 264;
  --primary-700: 0.4 0.192 264;
  --primary-800: 0.33 0.156 264;
  --primary-900: 0.26 0.122 264;
  --primary-950: 0.19 0.086 264;

  --secondary-50: 0.985 0.002 265;
  --secondary-100: 0.952 0.003 265;
  --secondary-200: 0.905 0.004 265;
  --secondary-300: 0.845 0.005 265;
  --secondary-400: 0.735 0.006 265;
  --secondary-500: 0.615 0.007 265;
  --secondary-600: 0.5 0.008 265;
  --secondary-700: 0.4 0.008 265;
  --secondary-800: 0.3 0.007 265;
  --secondary-900: 0.22 0.006 265;
  --secondary-950: 0.15 0.005 265;

  --accent-50: 0.972 0.02 72;
  --accent-100: 0.94 0.042 72;
  --accent-200: 0.888 0.072 70;
  --accent-300: 0.822 0.1 68;
  --accent-400: 0.752 0.128 64;
  --accent-500: 0.678 0.148 60;
  --accent-600: 0.578 0.138 58;
  --accent-700: 0.478 0.118 56;
  --accent-800: 0.382 0.098 54;
  --accent-900: 0.29 0.078 53;
  --accent-950: 0.2 0.058 52;
}

.dark {
  --background-50: 0.15 0.004 265;
  --background-100: 0.19 0.005 265;
  --background-200: 0.25 0.006 265;
  --background-300: 0.33 0.006 265;
  --background-400: 0.45 0.007 265;
  --background-500: 0.58 0.007 265;
  --background-600: 0.68 0.006 265;
  --background-700: 0.78 0.005 265;
  --background-800: 0.86 0.004 265;
  --background-900: 0.92 0.003 265;
  --background-950: 0.97 0.002 265;

  --foreground-50: 0.17 0.006 265;
  --foreground-100: 0.22 0.006 265;
  --foreground-200: 0.3 0.007 265;
  --foreground-300: 0.45 0.008 265;
  --foreground-400: 0.58 0.008 265;
  --foreground-500: 0.68 0.007 265;
  --foreground-600: 0.78 0.006 265;
  --foreground-700: 0.84 0.005 265;
  --foreground-800: 0.89 0.004 265;
  --foreground-900: 0.93 0.003 265;
  --foreground-950: 0.97 0.002 265;
}

html,
body,
#root {
  height: 100%;
}

html {
  background-color: oklch(var(--background-50));
}

body {
  margin: 0;
  font-family: var(--font-body);
  background-color: oklch(var(--background-50));
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  overscroll-behavior: none;
}

/* Fără evidențierea albastră/ gri pe care iOS o pune peste butoane la atingere */
* {
  -webkit-tap-highlight-color: transparent;
}

/* Pe telefon ecranul umple EXACT zona vizibilă (rezolvă spațiul gol de sub buton pe iOS) */
@media (max-width: 767px) {
  .app-shell {
    height: var(--app-height, 100dvh);
  }
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}